import { DecimalPipe, I18nPluralPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomDecimalPipe } from './number.pipe';

@NgModule({
  imports: [CustomDecimalPipe],
  exports: [CustomDecimalPipe],
  providers: [DecimalPipe, I18nPluralPipe],
})
export class CustomDecimalPipeModule {}
